export default "__VITE_ASSET__1b9074dc__"